/**
 * VideoMember class
 * @param userUUID {String} User.uuid
 * @param memberType {String} SELF: SELF|PUBLISHER|SUBSCRIBER|INVITEE
 * @param publisher {Object|null}
 * @param invite {Object}
 * @param stream {Object}
 * @constructor
 */
class VideoMember {
  constructor(userUUID, { memberType, publisher, invite, stream }) {
    this.userUUID = userUUID;
    this.memberType = memberType;
    this.publisher = publisher || null;
    this.invite = invite || null;
    this.stream = stream || null;
    this.activity = null;
  }
}

export { VideoMember };
